var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"income"},[_c('SelectMonth',{attrs:{"mark":1,"startData":_vm.startData,"endData":_vm.endData},on:{"fMethod":_vm.getDate}}),_c('div',{ref:"chart",attrs:{"id":"exz"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }